import React from 'react';
import ReactDOM from 'react-dom';

import { bindUsingDOM } from '~sharedComponents/ExternalReference/common/bindUsingDOM';
import { getActionName } from '~sharedComponents/ExternalReference/common/getActionName';
import { addListeners } from '~sharedComponents/ExternalReference/common/addListeners';
import { serviceNames } from '~setup/OffersService';
import { TExportExternal } from '~sharedComponents/ExternalReference/common/types/types';
import { defaultConfigs } from '~sharedComponents/ExternalReference/common/defaults/configs';

const emptyDefaultConfig = {
    cart: {},
    perlgem: {},
    stardust: {}
};

export function ExportExternal<T>(props: TExportExternal<T>) {
    const { componentName, Component } = props;
    const bindEventName = getActionName.bind(componentName);
    const boundEventName = getActionName.bound(componentName);
    const readyEventName = getActionName.ready(componentName);

    const listener = async (event: CustomEvent) => {
        const {
            detail: { rootNode, config, translations },
            detail
        } = event;

        const getDiContainer = () => import('~setup/diContainer');
        const { diContainer, setConfig } = await getDiContainer();

        const siteConfig = diContainer.get(serviceNames.config);

        if (!siteConfig) {
            // @ts-ignore
            const { cart, perlgem, stardust } = window?.site?.config || emptyDefaultConfig;
            const serviceConfig = { ...defaultConfigs, ...cart, perlgem, stardust };

            setConfig(serviceConfig);
        }

        siteConfig.updateConfig(config || {});

        ReactDOM.render(<Component config={config} translations={translations} />, rootNode);
        dispatchEvent(new CustomEvent(boundEventName, { detail }));
    };

    bindUsingDOM({
        tagName: 'data-behaviour',
        tagValue: componentName,
        externalProps: props
    });

    addListeners({ eventName: bindEventName, listener });
    dispatchEvent(new CustomEvent(readyEventName, { detail: { componentName } }));
}
